import React, { useState } from "react";
// import { useContext } from "react";
// import { AuthContext } from "../context/authContext";

import Aboutus from "../components/aboutus/Aboutus";
import Hero2 from "../components/hero2/Hero2";
import Services from "../components/services/Services";

import RecentView from "../components/hero2/RecentView";
import WhyBookWithUs from "../components/hero2/WhyBookWithUs";
import Handpick from "../components/hero2/Handpick";
import AIChatWidget from "./AIChatWidget";

const Home = () => {
  // const { user } = useContext(AuthContext);
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div>
      <div className="relative w-full h-screen overflow-hidden">
        {/* Background Video */}
        {/* <video
          className="absolute top-0 left-0 w-full h-full object-cover z-[-1]"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          src="/28707-371213524.mp4"
        ></video> */}
        <div
          className="absolute top-0 left-0 w-full h-full bg-cover bg-center z-[-1]"
          style={{ backgroundImage: 'url("/pexels-denis.jpg")' }}
        ></div>

        {/* Centered Search and Content */}
        <div className="flex flex-col items-center justify-center h-full text-white z-10 relative text-center px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-sky-400 via-amber-300 to-orange-400 bg-clip-text text-transparent drop-shadow-[2px_2px_6px_rgba(0,0,0,0.8)]">
            Find Your Perfect Journey
          </h1>
          <p
            className="text-lg md:text-2xl mb-8 max-w-2xl text-cyan-500 font-bold"
            style={{ textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)" }}
          >
            Find your perfect tour and travel package — tailored adventures to
            explore the world hassle-free!
          </p>
    
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const searchTerm = e.target.elements.search.value.trim();
              if (searchTerm) {
                window.location.href = `/packagelist?search=${encodeURIComponent(
                  searchTerm
                )}`;
              }
            }}
            className="w-full max-w-lg"
          >
    
            <div className="relative w-full">
              <input
                name="search"
                type="text"
                placeholder="Where do you want to go?"
                className="px-6 py-3 pr-12 rounded-full w-full text-black shadow-lg focus:outline-none"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="absolute right-4 top-1/2 transform -translate-y-1/2 h-6 w-6 text-gray-500 pointer-events-none"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </form>
        </div>
      </div>
      <Hero2 />
      <Aboutus />
      <Services />
      <Handpick />
      <WhyBookWithUs />
      {/* <Hero3 /> */}
      <RecentView />
      <AIChatWidget />
    </div>
  );
};

export default Home;
